module.exports = __webpack_public_path__ + "static/media/overview-1.7d4757e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/yelp/src/overview-1.jpg
// module id = 650
// module chunks = 0